import axios from 'axios';

export default {
  getAll({ commit }) {
    return axios.get('task')
      .then((response) => {
        commit('setTasks', response.data);
      });
  },
  fetchTaskList({
    commit,
  }, params) {
    commit('setLoading', true);
    commit('setError', false);
    console.log(params);
    const { parentResource, parentResourceId } = params;
    let uri = '/';

    if (parentResource && parentResourceId) {
      uri += `${parentResource}/${parentResourceId}/`;
    }
    uri += 'task';

    return axios.get(uri, {
      params,
    })
      .then((tasks) => {
        commit('setData', tasks);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  saveTask({ commit }, params) {
    return axios.post('/task', params)
      .then(({ data }) => {
        commit('updateTask', data);
      });
  },
  addTask({ commit }, params) {
    return axios.post('/task', params)
      .then(({ data }) => {
        commit('addTask', data);
      });
  },
  deleteTask({ commit }, task) {
    return axios.delete(`/task/${task.id}`)
      .then(({ data }) => {
        if (data && data.id) commit('removeTask', data.id);
      });
  },
  saveNotes(_, params) {
    return axios.post('/note', params);
  },
};
